
import { DashboardMenu } from "../../data/menu"
import BreadCrump from "../tools/breadcrump"
import { getCookies } from "cookies-next";
import { useEffect, useState } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
import changeUrl from "../../hoc/changeur";
import { config } from "../../data/config";
import ImageUploader from "../tools/uploaderImage"
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import HeaderOfPage from "../tools/headerOfPage";

// Helper function to get multilingual value
const getMultilingualValue = (field: any, lang: string = 'en'): string => {
    if (!field) return '';
    if (typeof field === 'string') return field;
    if (typeof field === 'object') {
        return field[lang] || field.en || field.ku || field.fa || field.ar || field.tr || '';
    }
    return '';
};

export default function ListGallery() {
    const { t } = useTranslation();
    const [languages, setLanguages] = useState<Array<{ code: string; label: string }>>([]);

    const loadLanguages = async () => {
        try {
            const res = await axios.get(`${config.url}/v1/language`);
            const languageList = res.data?.message ?? [];
            const mapped = languageList
                .filter((lang: any) => lang.active)
                .sort((a: any, b: any) => (a.arranged ?? 0) - (b.arranged ?? 0))
                .map((lang: any) => ({ code: lang.code, label: lang.label }));
            setLanguages(mapped);
        } catch (e) {
            console.error('Error loading languages:', e);
            setLanguages([
                { code: 'ku', label: 'Kurdish' },
                { code: 'fa', label: 'فارسی' },
                { code: 'en', label: 'English' },
                { code: 'ar', label: 'العربية' },
                { code: 'tr', label: 'Türkçe' }
            ]);
        }
    };

    useEffect(() => {
        loadLanguages();
    }, []);

    const breadcrump = [
        {
            name: 'Dashboard',
            url: '/dashboard'
        },
        {
            name: 'گالری',
            url: '/dashboard/Gallery'
        },
        {
            name: 'Slider List',
            url: null
        },
    ]
    const reloadgame = () => {
        let x = key + 1;
        setKey(x);
    }
    const [key, setKey] = useState<any>(1);

    return (
        <>
            <div className="text-left directions  bg-white  p-3 m-4   h-[100vh] mb-5 ">
                <BreadCrump data={breadcrump}></BreadCrump>
                <HeaderOfPage name="لیست اسلایدر"></HeaderOfPage>

                <div className="grid grid-cols-1 sm:grid-cols-4 gap-4">
                    <div className="col-span-1">
                        <NewBlogCategory reloaditem={reloadgame} languages={languages}></NewBlogCategory>

                    </div>
                    <div className="col-span-3">
                        <ListofBlog key={key} languages={languages}></ListofBlog>
                    </div>
                </div>
            </div>

        </>
    )
}
function ListofBlog({ languages = [] }: { languages?: Array<{ code: string; label: string }> }) {
    const { t } = useTranslation();
    const langList = languages.length > 0 ? languages : [
        { code: 'ku', label: 'Kurdish' },
        { code: 'fa', label: 'فارسی' },
        { code: 'en', label: 'English' },
        { code: 'ar', label: 'العربية' },
        { code: 'tr', label: 'Türkçe' }
    ];
    const [currentLang, setCurrentLang] = useState<string>(langList[0]?.code ?? i18next.language ?? 'en');

    let cookie = getCookies();
    const [list, setList] = useState<any>(null);

    const [error, setError] = useState<any>(null);
    const [key, setKey] = useState<any>(1);

    const getalldata = async () => {
        setError(null);

        try {
            let res = await axios({
                method: 'get',
                url: config.url + '/v1/dashboard/slider',
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });

            //let mydata = res.data;
            //  console.log(config.url + '/v1/dashboard/bloggroup')
            //  console.log(res);
            setList(res.data.message);
        } catch (error: any) {

            // error.response.data.code != null && Swal.fire(` "${data.url}" slug is available.`);
            setError(error.response.data.message.errors);
        }
    }
    const deleted = async (id: any) => {
        Swal.fire({
            title: t("Are you sure?"),
            text: t("Delete this Group!"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: t("Yes, delete it!")
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    let res = await axios({
                        method: 'delete',
                        url: config.url + '/v1/dashboard/slider/' + id,
                        headers: {
                            Authorization: 'Bearer ' + cookie['token'],
                        }
                    })

                    getalldata();
                } catch (error) {
                    console.log(error);
                }
            }
        });

    }
    useEffect(() => {
        getalldata();
    }, []);
    return (
        <div className="directions">
            {/* Language Selector */}
            <div className="mb-4 flex items-center gap-3">
                <span className="text-sm font-medium text-gray-700">زبان نمایش / Display Language:</span>
                <div className="flex gap-2 flex-wrap">
                    {langList.map((lang) => (
                        <button
                            key={lang.code}
                            type="button"
                            onClick={() => setCurrentLang(lang.code)}
                            className={`px-3 py-1.5 text-sm font-medium rounded-lg transition-colors ${
                                currentLang === lang.code
                                    ? 'bg-blue-600 text-white'
                                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                            }`}
                        >
                            {lang.label}
                        </button>
                    ))}
                </div>
            </div>

            <div className="flex flex-col text-right">
                <div className="-m-1.5 overflow-x-auto">
                    <div className="p-1.5 min-w-full inline-block align-middle">
                        <div className="overflow-hidden">
                            <table className="min-w-full divide-y divide-gray-200 ">
                                <thead>
                                    <tr>
                                        <th scope="col" className="px-6 py-3  text-xs font-medium text-gray-500 uppercase ">
                                            {t('Name')} ({langList.find(l => l.code === currentLang)?.label})
                                        </th>
                                        <th scope="col" className="px-6 py-3  text-xs font-medium text-gray-500 uppercase ">{t('SLUG')} </th>
                                        <th scope="col" className="px-6 py-3  text-xs font-medium text-gray-500 uppercase  ">{t('Action')} </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {list != null && list.map((item: any) => {
                                        return (
                                            <tr className="odd:bg-white even:bg-gray-100 hover:bg-gray-100 ">
                                                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800 ">
                                                    {getMultilingualValue(item.name, currentLang)}
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800 ">{item.url}</td>

                                                <td className="px-6 py-4 whitespace-nowrap text-center text-sm font-medium flex gap-2">
                                                    <a
                                                        href={`/dashboard/Gallery/list/${item.id}`}
                                                        type="button"
                                                        className=" gap-x-2 text-sm font-semibold rounded-lg border border-transparent text-blue-600 hover:text-blue-800 focus:outline-none focus:text-blue-800 disabled:opacity-50 disabled:pointer-events-none "
                                                    >
                                                        <img src="/icons/editgreen.svg" width={20} alt="Edit" />
                                                    </a>

                                                    <button
                                                        onClick={(e) => { deleted(item.id) }}
                                                        type="button"
                                                        className=" gap-x-2 text-sm font-semibold rounded-lg border border-transparent text-blue-600 hover:text-blue-800 focus:outline-none focus:text-blue-800 disabled:opacity-50 disabled:pointer-events-none "
                                                    > <img src="/icons/delred.svg" width={20} alt="Del" /> </button>
                                                </td>

                                            </tr>
                                        )
                                    })}



                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
type MultilingualField = Record<string, string>;

const initializeMultilingualField = (field: any, languageCodes: string[]): MultilingualField => {
    if (!field) {
        const obj: MultilingualField = {};
        languageCodes.forEach(code => obj[code] = '');
        return obj;
    }
    if (typeof field === 'string') {
        const obj: MultilingualField = {};
        languageCodes.forEach(code => obj[code] = field);
        return obj;
    }
    if (typeof field === 'object') {
        const obj: MultilingualField = { ...field };
        languageCodes.forEach(code => { if (obj[code] == null) obj[code] = ''; });
        return obj;
    }
    const obj: MultilingualField = {};
    languageCodes.forEach(code => obj[code] = '');
    return obj;
};

function NewBlogCategory({ reloaditem, languages = [] }: { reloaditem: () => void; languages?: Array<{ code: string; label: string }> }) {
    const { t } = useTranslation();
    const langList = languages.length > 0 ? languages : [
        { code: 'ku', label: 'Kurdish' },
        { code: 'fa', label: 'فارسی' },
        { code: 'en', label: 'English' },
        { code: 'ar', label: 'العربية' },
        { code: 'tr', label: 'Türkçe' }
    ];
    const languageCodes = langList.map(l => l.code);

    let cookie = getCookies();
    const [data, setData] = useState<any>({
        name: {} as MultilingualField,
        url: '',
        keywords: {} as MultilingualField,
        description: {} as MultilingualField,
        parent: null
    });
    const [error, setError] = useState<any>(null);
    const [key, setKey] = useState<any>(1);
    const [activeLang, setActiveLang] = useState<string>(langList[0]?.code ?? 'en');

    useEffect(() => {
        if (languageCodes.length === 0) return;
        setData((prev: any) => ({
            ...prev,
            name: initializeMultilingualField(prev.name, languageCodes),
            keywords: initializeMultilingualField(prev.keywords, languageCodes),
            description: initializeMultilingualField(prev.description, languageCodes),
        }));
        if (langList[0]) setActiveLang(langList[0].code);
    }, [languageCodes.join(',')]);

    const getMultilingualValue = (field: MultilingualField, lang: string): string => {
        return (field && field[lang]) || '';
    };

    const setName = (name: string) => {
        const updatedName = { ...data.name, [activeLang]: name };
        let newUrl = data.url;
        const firstLang = langList[0]?.code ?? 'en';
        if (activeLang === firstLang) {
            newUrl = String(changeUrl(name));
        }
        setData({ ...data, url: newUrl, name: updatedName });
    }
    const save = async () => {
        setError(null);

        try {
            let res = await axios({
                method: 'post',
                url: config.url + '/v1/dashboard/slider',
                data: data,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });

            let mydata = res.data;
            const empty: MultilingualField = {};
            languageCodes.forEach(code => empty[code] = '');
            setData({
                name: { ...empty },
                url: '',
                keywords: { ...empty },
                description: { ...empty },
                parent: null
            });
            reloaditem();
            let x = key + 1;
            setKey(x);
            return mydata;
        } catch (error: any) {

            error.response.data.code != null && Swal.fire(` "${data.url}" slug is available.`);
            setError(error.response.data.message.errors);
        }
    }

    const inputstyle = "py-3 px-5 block w-full border-gray-499 rounded text-sm focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none";
    return (
        <div className=" bg-black rounded-[10px] p-5 text-right">
            <h4 className="text-white text-[20px] font-bold ">{t('New Gallery')}</h4>
            <hr />

            <form key={key}>
                {/* Language Selector */}
                <div className="max-w-sm space-y-3">
                    <label className="text-white">زبان / Language</label>
                    <div className="flex gap-2 flex-wrap">
                        {langList.map((lang) => (
                            <button
                                key={lang.code}
                                type="button"
                                onClick={() => setActiveLang(lang.code)}
                                className={`px-3 py-1.5 text-sm font-medium rounded-lg transition-colors ${
                                    activeLang === lang.code
                                        ? 'bg-blue-600 text-white'
                                        : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
                                }`}
                            >
                                {lang.label}
                            </button>
                        ))}
                    </div>
                </div>
                <div className="max-w-sm space-y-3 mt-4 text-start">
                    <label className="text-white">{t('Name')} ({langList.find(l => l.code === activeLang)?.label})</label>
                    <input
                        type="text"
                        value={getMultilingualValue(data.name, activeLang)}
                        className={`${inputstyle}     ${error != null && error['name'] != undefined && `bg-red-100`} `}
                        placeholder="Name"
                        onChange={(e) => { setName(e.target.value); }}
                    />
                    {error != null && error['url'] != undefined && <small>{error['name']['message']}</small>}
                </div>
                <div className="max-w-sm space-y-3 mt-4">
                    <label className="text-white">{t('Slug')}   </label>
                    <input
                        value={data.url}
                        type="text"
                        className={`${inputstyle}       ${error != null && error['url'] != undefined && `bg-red-100`}  `}
                        placeholder="Slug"
                        onChange={(e) => setData({ ...data, url: e.target.value })}
                    />
                    {error != null && error['url'] != undefined && <small>{error['url']['message']}</small>}
                </div>
                <div className="max-w-sm space-y-3 mt-4">
                    <label className="text-white">{t('Keywords')} ({langList.find(l => l.code === activeLang)?.label})</label>
                    <textarea
                        value={getMultilingualValue(data.keywords, activeLang)}
                        className={inputstyle}
                        onChange={(e) => setData({ 
                            ...data, 
                            keywords: { 
                                ...data.keywords, 
                                [activeLang]: e.target.value 
                            } 
                        })}
                        placeholder="..." />
                </div>
                <div className="max-w-sm space-y-3 mt-4">
                    <label className="text-white">{t('Description')} ({langList.find(l => l.code === activeLang)?.label})</label>
                    <textarea
                        value={getMultilingualValue(data.description, activeLang)}
                        className={inputstyle}
                        onChange={(e) => setData({ 
                            ...data, 
                            description: { 
                                ...data.description, 
                                [activeLang]: e.target.value 
                            } 
                        })}
                        placeholder="..." />
                </div>
                <div className="max-w-sm space-y-3 mt-4">
                    <button type="button"
                        onClick={(e) => { save() }}
                        className="py-3 px-4 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-transparent bg-gray-100 text-gray-800 hover:bg-gray-200 focus:outline-none focus:bg-gray-200 disabled:opacity-50 disabled:pointer-events-none dark:bg-white/10 dark:text-white dark:hover:bg-white/20 dark:hover:text-white dark:focus:bg-white/20 dark:focus:text-white"
                    >
                        {t(' اضافه کردن اسلایدر')}
                    </button>

                </div>
            </form>
        </div>
    )
}